export default __webpack_public_path__ + "6cebbd0b0f3cda32d3675eadaa40dac6.png";